/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  ActionSortInput,
  ActionFilterInput,
  useGetCustomActionsQuery,
} from "~/generated/graphql";

type Props = {
  page: string;
  limit: string;
  sort: ActionSortInput;
  filter?: ActionFilterInput;
  skip?: boolean;
  includeRelatedPlansCount?: boolean;
};

export function useGetCustomActions({
  page,
  limit,
  sort,
  filter,
  skip,
  includeRelatedPlansCount = false,
}: Props) {
  const { data, loading, error } = useGetCustomActionsQuery({
    variables: {
      page: Number(page),
      limit: Number(limit),
      sort,
      filter,
      includeRelatedPlansCount,
    },
    skip,
  });
  const count = data?.actions.pageInfo?.count ?? 0;

  return { data: data?.actions?.result ?? [], loading, error, count } as const;
}
